import { ReactElement, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { DocumentTimelineStatus } from '@features/invoices/elements/DocumentTimelineStatus'
import { InvoiceEvent } from '@features/invoices/types/invoices/invoiceEvent'

import { DEMO_INVOICE_EVENT_TYPE_TO_TRANSLATION_KEY } from '../../constants/demoInvoiceEventTypeToTranslationKey'
import { DemoInvoiceSendChannel } from '../../enums/demoInvoiceSendChannel'
import { getDemoInvoiceSentEvents } from '../../utils/getDemoInvoiceSentEvents'

interface DemoInvoiceSentTimelineProps {
  channel: DemoInvoiceSendChannel
  sentAt: Date
}

export const DemoInvoiceSentTimeline = ({ channel, sentAt }: DemoInvoiceSentTimelineProps): ReactElement => {
  const { t } = useTranslation()
  const events = useMemo(() => getDemoInvoiceSentEvents(sentAt, channel), [channel, sentAt])

  const getItemTitle = useCallback(
    ({ eventType }: InvoiceEvent): string => t(DEMO_INVOICE_EVENT_TYPE_TO_TRANSLATION_KEY[eventType] ?? eventType),
    [t],
  )

  return (
    <DocumentTimelineStatus
      events={events}
      getItemTitle={getItemTitle}
      isLoading={false}
      title={t('external_invoices.view.sidebar.timeline.title')}
    />
  )
}
